Vue.component('source-stat', {
    props: ['source', 'source_name', 'past_source', 'goals'],
    data() {
        return {
            showOptions: false,
        }
    },
    computed: {

        pastValue() {
            return this.past_source ? this.past_source.count : 0
        },

        pastAverage() {
            return this.past_source ? this.past_source.average : 0
        },

        periodDiff() {
            return this.source.average - this.pastAverage
        },

        activeGoals() {
            return this.goals.filter( function(g) { return g.is_active; } )
        },

        goalText() {
            return this.activeGoals.length ? 'View active goal' : 'Set a new goal'
        },

        sourceTooltipText() {

            let source_name = this.source_name
            let source = this.source

            let markup = '<div class="header">' + this.sourceLabelFromSlug(source_name) + '</div>'

            markup += '<div class="body">'

            markup += '<p class="label">Average Score</p>'

            let arrow_classes = source.average > 122 ?
                "ei-arrow_up" : "ei-arrow_down"

            let arrow_parent_classes = source.average > 122 ?
                "text-success" : "text-danger"

            let diff = (source.average - 122).toFixed(2)

            // Show a simple hyphen when the score is the same or the arrow
            // when the score has changed
            let arrow = source.average != 122 ?
                '<span class="' + arrow_parent_classes +'"><i class="' + 
                arrow_classes + '"></i>' + diff + '</span>'
                : ''

            // Add score section
            markup += '<p class="mb-1"><span class="number-s"><strong>' + source.average +
                '</strong></span>' + arrow + '</p>'

            let total_arrow_classes = source.count > 15999 ?
                "ei-arrow_up" : "ei-arrow_down"

            let total_arrow_parent_classes = source.count > 15999 ?
                "text-success" : "text-danger"

            let total_arrow = source.count != 15999 ?
                '<span class="' + total_arrow_parent_classes +'"><i class="' + 
                total_arrow_classes + '"></i>' + (source.count - 15999)
                    + '</span>' : ''

            // Add total reviews section
            markup += '<p class="my-0"><small>(' + source.count + ' reviews' + total_arrow + ')</small></p>'
            markup += '</div>'

            return markup
        }
    },
    watch: {
        /** 
        * This watch refresh the directive with the new value, 
        * maybe there is an other way 
        */
        source: function () {
            this.$forceUpdate();
        },
        ariaDescribedby: function(newValue, oldValue) {
        }
    },
    mounted() {
        Vue.nextTick(function () {
            $('[data-toggle="tooltip"]').tooltip()
        })
    },
    methods: {
        handleGoalCallback() {
            if (this.activeGoals.length) {
                this.$eventHub.$emit('toggleGoalAction',  {action: 'view', source_name: this.source_name})
            } else {
                this.$eventHub.$emit('toggleGoalAction',  {action: 'new', source_name: this.source_name})
            }
        },
        updateTooltip(event) {
            
            var elem = event.toElement

            id = elem.getAttribute('aria-describedby')

            if (! id) {
                return
            }

            tooltip = document.getElementById(id)
            tooltip.querySelector('.tooltip-inner').innerHTML = this.sourceTooltipText

        },
        toggleOptions() {
            this.showOptions = ! this.showOptions
        },
        filterChannel(sourceName) {

            this.$eventHub.$emit('goToSourceReviews', sourceName)
            
        },
    }
})